import { QueryProvider } from '@shared/providers';
import { ThemeProvider } from '@shared/theme';

import type { ReactNode } from 'react';

/**
 * Root providers, kept in one place and mounted outside the router so query
 * state survives navigation.
 *
 * When HeroUI v2 components are introduced, wrap children in `<HeroUIProvider>`
 * from `@veevarts/design-system` here (outermost), matching the portal's
 * provider order (ADR-0009).
 */
export function Providers({ children }: { children: ReactNode }) {
    /*
     * `ThemeProvider` sits outside `QueryProvider` because it depends on
     * nothing — not the session, not the API, not the router. It only reads
     * localStorage and `matchMedia`, and putting it outermost means the theme
     * survives every remount underneath it, including the auth gate bouncing
     * an unauthenticated employee to Atelier.
     */
    return (
        <ThemeProvider>
            <QueryProvider>{children}</QueryProvider>
        </ThemeProvider>
    );
}
